import { render, staticRenderFns } from "./DelinquentTaxBrowse.vue?vue&type=template&id=b0e361d8&scoped=true&"
import script from "./DelinquentTaxBrowse.vue?vue&type=script&lang=js&"
export * from "./DelinquentTaxBrowse.vue?vue&type=script&lang=js&"
import style0 from "./DelinquentTaxBrowse.vue?vue&type=style&index=0&id=b0e361d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e361d8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
